import { checkLogin } from "lib/check_login";
import client from "../client";

export interface ExchangeSMPointRequest {
  id?: number;
}

export default function API(request: ExchangeSMPointRequest) {
  if (!checkLogin()) {
    return Promise.reject({
      response: {
        data: {
          message: "กรุณาเข้าสู่ระบบ",
        },
      },
    });
  }

  return client
    .post(`payment/exchange_sm_point`, request)
    .then((response) => response.data);
}
